<template>
  <section class="tutor-list-faq">
    <CommonFAQs />
  </section>
</template>

<script>
import CommonFAQs from '@design-system/section/faqs/faqs.old.vue'
export default {
  name: 'SectionTutorListFaq',
  components: {
    CommonFAQs
  }
}
</script>

<style lang="scss">
.tutor-list-faq {
  &__ul {
    @apply list-disc list-inside;
    li {
    }
  }
}
</style>
